/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const ExportRequestStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  waiting: {
    name: 'รอจัดสินค้า',
    color: 'warning',
    icon: 'hourglass_top',
  },
  request: {
    name: 'หยิบสินค้า',
    color: 'info',
    icon: 'real_estate_agent',
  },
  arrange: {
    name: 'ตรวจบางรายการ',
    color: 'info',
    icon: 'inventory_2',
  },
  close: {
    name: 'ปิดการจอง',
    color: 'error',
    icon: 'visibility_off',
  },
  success: {
    name: 'ตรวจครบถ้วน',
    color: 'success',
    icon: 'task_alt',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default ExportRequestStatus;
